import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';

export enum LeaveVenue {
	NAVIGATE_BACK = 'back',
	STAY = 'stay',
}
@Component({
	selector: 'app-change-venue-popover',
	templateUrl: './change-venue-popover.component.html',
	styleUrls: ['change-venue-popover.component.scss'],
})
export class ChangeVenuePopoverComponent implements OnInit {
	leaveEnum = LeaveVenue;
	constructor(
		private popover: PopoverController,
		private router: Router
	) {}

	ngOnInit() {}
	dismiss(value: LeaveVenue) {
		this.popover.dismiss(value);
	}
	goHome() {
		this.popover.dismiss(this.leaveEnum.NAVIGATE_BACK).then(() => {
			this.router.navigate(['/home']);
		});
	}
}
